module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_03 (2).ad4e7ec7.png";